<div class="navigation-block">
	<div class="navigation-block-header d-flex justify-content-between pb-1">
		{{ 'catalog-view.searchbar.search-in-catalog' | translate }}
		<div class="d-flex">
			@if (currentSearchWord !== '') {
				<div
					(click)="clearSearch()"
					[ngbTooltip]="'searchbar.delete' | translate"
					class="cursor-pointer action-button bg-dark mask-settings close-cross-mask-img"></div>
			}
			@if (currentViewType === viewType.Desktop) {
				<div
					[ngbTooltip]="'searchbar.explicit-search-hint' | translate"
					[container]="'body'"
					class="action-button bg-dark mask-settings info-mask-img"></div>
			}
		</div>
	</div>
	<div class="mt-2 searchbar-group searchbar searchbar-header searchbar-catalog" id="searchbarcontainer">
		<div class="input-group bg-transparent w-100 d-flex flex-row">
			<div class="input-group" id="searchbar-group">
				<label for="searchbar" class="visuallyhidden">{{ placeholder }}</label>
				<input
					#searchbarInput
					type="text"
					(blur)="closeSuggestions()"
					class="form-control catalog-searchbar-input searchbar-input cursor-text typeahead searchbar-placeholder ms-0 border-0 d-block"
					id="searchbar"
					[(ngModel)]="currentSearchWord"
					autocomplete="off"
					(keydown)="onKeyDown($event)"
					(touchstart)="hasBlur(false)"
					[placeholder]="placeholder"
					(ngModelChange)="changeSearchSuggestions($event)"
					(click)="changeSearchSuggestions(currentSearchWord)" />
				@if (suggestions || additionalItems?.length > 0) {
					<div
						class="position-absolute no-user-select w-100"
						(mousedown)="hasBlur(false)"
						(touchstart)="hasBlur(false)"
						(mouseleave)="hasBlur(true)"
						style="top: 2rem">
						<div
							[ngClass]="currentViewType === viewType.Desktop ? 'position-fixed' : 'position-relative w-100'"
							class="bg-white input-menu">
							@if (suggestions) {
								@if (currentViewType === viewType.Mobile) {
									<div class="p-1 mx-1 border-bottom align-items-center d-flex">
										<div class="icon-default mask-settings info-mask-img bg-gray-500"></div>
										<div class="ms-1 hyphens text-gray-500">{{ 'searchbar.explicit-search-hint' | translate }}</div>
									</div>
								}
								@for (term of suggestedTerms; track term) {
									<div
										(click)="searchItem(term, false)"
										class="cursor-pointer one-line text-truncate d-block overflow-hidden"
										[ngClass]="term === indexedSearchterm ? 'bg-primary' : 'bg-gray-200-hover'">
										<div class="p-2 mx-1 one-line" [innerHtml]="term | searchhighlight: currentSearchTerm"></div>
									</div>
								}
								@if (suggestedCatalogs?.length > 0) {
									<div (mousedown)="$event.preventDefault()" class="px-2 mx-1 py-1 text-gray-600 border-top fw-semibold">
										{{ 'catalog-view.searchbar.further-catalogs' | translate }}
									</div>
								}
								@for (catalog of suggestedCatalogs; track catalog) {
									<div
										[attr.aria-description]="'catalog with key ' + catalog.key"
										(click)="navigateToCatalog(catalog.key)"
										class="text-decoration-none text-dark cursor-pointer"
										data-toggle="list"
										role="tab">
										<div
											[ngClass]="
												catalog.key === indexedCatalogKey ? 'bg-primary' : 'bg-gray-200-hover bg-transparent'
											"
											class="d-flex px-2 py-1 img-holder-hovereffekt-wrapper">
											<div class="img-holder img-holder-hover ms-1 img-holder-small">
												<lib-catalog-logo-img
													[catalogKey]="catalog.key"
													[isSmall]="true"
													[alt]="catalog?.title"
													height="2.36rem"
													width="3.93rem"
													loading="lazy" />
											</div>
											<div class="ps-2 item-max-width">
												<div class="d-flex justify-content-between">
													<div class="one-line">
														<div [innerHtml]="catalog.title | searchhighlight: currentSearchTerm"></div>
													</div>
												</div>
												<div class="one-line text-small">
													<span>{{ getCatalogCategories(catalog) }}</span>
												</div>
											</div>
										</div>
									</div>
								}
							}
							@if (additionalItems?.length > 0) {
								<div
									[class.border-top]="suggestions"
									(mousedown)="$event.preventDefault()"
									class="px-2 mx-1 py-1 text-gray-600 fw-semibold">
									{{ 'catalog-view.searchbar.search-in-other' | translate }}
								</div>
							}
							@for (item of additionalItems; track item) {
								<div
									class="text-decoration-none text-dark cursor-pointer"
									(click)="handleAdditionalItem(item)"
									data-toggle="list"
									role="tab">
									<div
										[ngClass]="item.id === indexedAdditionalId ? 'bg-primary' : 'bg-gray-200-hover bg-transparent'"
										class="d-flex px-2 py-1 img-holder-hovereffekt-wrapper">
										<div class="img-holder img-holder-hover ms-1 img-holder-small">
											<div class="img">
												<img
													[src]="item.logo"
													loading="lazy"
													lazyload="1"
													onError="this.src='assets/material/no_photo.svg'"
													[alt]="item.title" />
											</div>
										</div>
										<div class="ps-2 item-max-width">
											<div class="d-flex justify-content-between">
												<div class="one-line">
													<div [innerHtml]="item.title"></div>
												</div>
											</div>
											<div class="one-line text-small">
												<span [innerHTML]="item.description"></span>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					</div>
				}

				<!-- Suchicon -->
				<div class="catalog-search-button-container">
					<button
						class="btn btn-outline-dark search-button"
						aria-label="search-button"
						type="button"
						(click)="searchItem(currentSearchWord, true)"
						(mousedown)="hasBlur(false)">
						<div class="cursor-pointer catalog-search-img bg-dark no-user-select mask-settings searchbar-action-mask-img"></div>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
